/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientContactMappingDto = {
    id: number;
    clientId: number;
    /**
     * The accounting provider this mapping is for (lexoffice/sevdesk)
     */
    providerType: string;
    externalContactId: string;
    externalContactName: string;
    externalContactEmail?: string | null;
    externalContactStreet?: string | null;
    externalContactCity?: string | null;
    mappingType: ClientContactMappingDto.mappingType;
    createdAt: string;
    updatedAt: string;
};
export namespace ClientContactMappingDto {
    export enum mappingType {
        MANUAL = 'manual',
        AUTO = 'auto',
        SUGGESTED = 'suggested',
    }
}

